exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".provider-panel--28-LPIT03zK2YhzHWTW1MQ {\n  display: flex;\n  align-items: center;\n  gap: .25rem;\n}\n\n.provider-panel--3R5ZSxu1lWRrzHtAhH8igC {\n  line-height: .875rem;\n  min-height: 0;\n  margin-top: -0.25rem;\n}\n", ""]);

// exports
exports.locals = {
	"labelWrapper": "provider-panel--28-LPIT03zK2YhzHWTW1MQ",
	"labelWrapper": "provider-panel--28-LPIT03zK2YhzHWTW1MQ",
	"subLabelWrapper": "provider-panel--3R5ZSxu1lWRrzHtAhH8igC",
	"subLabelWrapper": "provider-panel--3R5ZSxu1lWRrzHtAhH8igC"
};